<h1 class="h1 text_algn text-center" style="color:#0064A5;">Branch Change Portal</h1>
<p class="lead text_algn text-center">Change Your Home Branch Here.</p>
<div class="container">
  <div class="col-lg-12">
    <div class="row">
      <div class="offset-lg-3 col-lg-6">
        <div class="card mt-5">
          <div class="card-header cheader">
            One Time Password
          </div>
          <div class="card-body">
            <div class="form-horizontal">
                <!-- Text input-->
                <div class="form-group">                  
                  <div class="col-md-12">
                    <label class="col-md-12 control-label" for="textinput">{{phone_no}}</label>
                    <input [(ngModel)]="userotp" id="textinput" name="textinput" 
                    type="text" placeholder="Enter OTP Here" (ngModelChange)="disableGenerateButton()"
                      class="form-control input-md" autocomplete="off" knifeOnlyNumbers maxlength="6">
                      <label class="text-danger">{{otp_response}}</label>
                  </div>
                </div>              

                <!-- submit button -->
                <div class="form-group ">
                  <!-- <label class="col-md-12 control-label" for="passwordinput">Password Input</label> -->
                  <div class="col-md-12 ">
                    <button (click)="VALOTP()" [disabled]="isDisabled" class="btn btn-info btn-block">Verify</button>
                    <span class="text-primary" style="cursor: pointer;" (click)="resendOTP()">
                      Resend OTP</span>
                  <span class="text-primary" style="cursor: pointer;float: right;" 
                  (click)="generateOTPviacall()"
                    *ngIf="otpcall">Receive OTP via Call</span>
                  </div>
                </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
  <p style="color: white">Please Wait. </p>  
  </ngx-spinner>